
const validateForm = (form, firtsForm = false) => {
  let errors = {};
  if (!form.person_address_street) {
    errors.street = 'Direccion es requerida';
  }
  if (!form.person_address_number) {
    errors.number = 'Número de direccion es requerido';
  }
  if (!form.person_address_zipcode) {
    errors.zipcode = 'Código Postal es requerido';
  }
  if (!form.person_phone) {
    errors.phone = 'Número de teléfono es requerido';
  }
  if (!form.person_mail) {
    errors.mail = 'Email es requerido';
  }

  //validate errors for button 

  if (errors.street || errors.number || errors.phone || errors.zipcode || errors.mail || errors.dni || errors.otp) {
    errors.validate = true;
  } else {
    errors.validate = false;
  }

  return errors;
};


export default validateForm;
